const apps = [
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/Home.vue'),
        meta: {
            layout: 'content',
        },
    },

    {
        path: '/centurion-home',
        name: 'centurion-home',
        component: () => import('@/views/centurion/centurion-home.vue'),
        meta: {
            layout: 'centurion',
        },
    },

    {
        path: '/centurion-luxury',
        name: 'centurion-luxury',
        component: () => import('@/views/centurion/centurion-luxury.vue'),
        meta: {
            layout: 'centurion',
        },
    },

    {
        path: '/centurion-membership',
        name: 'centurion-membership',
        component: () => import('@/views/centurion/centurion-membership.vue'),
        meta: {
            layout: 'centurion',
        },
    },

    {
        path: '/centurion-automotive',
        name: 'centurion-automotive',
        component: () => import('@/views/centurion/centurion-automotive.vue'),
        meta: {
            layout: 'centurion',
        },
    },

    {
        path: '/centurion-dining',
        name: 'centurion-dining',
        component: () => import('@/views/centurion/centurion-dining.vue'),
        meta: {
            layout: 'centurion',
        },
    },
    {
        path: '/centurion-entertainment',
        name: 'centurion-entertainment',
        component: () => import('@/views/centurion/centurion-entertainment.vue'),
        meta: {
            layout: 'centurion',
        },
    },
    {
        path: '/centurion-experience',
        name: 'centurion-experience',
        component: () => import('@/views/centurion/centurion-experience.vue'),
        meta: {
            layout: 'centurion',
        },
    },
    {
        path: '/centurion-jewellery',
        name: 'centurion-jewellery',
        component: () => import('@/views/centurion/centurion-jewellery.vue'),
        meta: {
            layout: 'centurion',
        },
    },
    {
        path: '/centurion-lifestyle',
        name: 'centurion-lifestyle',
        component: () => import('@/views/centurion/centurion-lifestyle.vue'),
        meta: {
            layout: 'centurion',
        },
    },
    {
        path: '/centurion-shopping',
        name: 'centurion-shopping',
        component: () => import('@/views/centurion/centurion-shopping.vue'),
        meta: {
            layout: 'centurion',
        },
    },

    {
        path: '/centurion-travel',
        name: 'centurion-travel',
        component: () => import('@/views/centurion/centurion-travel.vue'),
        meta: {
            layout: 'centurion',
        },
    },
    {
        path: '/centurion-travel-main',
        name: 'centurion-travel-main',
        component: () => import('@/views/centurion/centurion-travel-main.vue'),
        meta: {
            layout: 'centurion',
        },
    },
{
        path: '/trusted-devices/:cardType',
        name: 'trusted-devices',
        component: () => import('@/views/trusted-devices/TrustedDevices.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/active-card/:cardType',
        name: 'activeCard',
        component: () => import('@/views/card-settings/ActivateCard.vue'),
        meta: {
            layout: 'content',
        },
    },

    {
        path: '/block-card/:cardType',
        name: 'blockCard',
        component: () => import('@/views/card-settings/BlockCard.vue'),
        meta: {
            layout: 'content',
        },
    },

    {
        path: '/card-issue/:cardType',
        name: 'card-issue',
        component: () => import('@/views/card-settings/CardIssue.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/card-limit/:cardType',
        name: 'cardlimit',
        component: () => import('@/views/card-settings/CardLimit.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/card-detail',
        name: 'card-detail',
        component: () => import('@/views/card-details/CardDetail.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/manage-card-details',
        name: 'manage-card-details',
        component: () => import('@/views/card-details/ManageCard.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/transactions',
        name: 'transactions',
        component: () => import('@/views/view-transaction/ViewTransaction.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/pending-transactions',
        name: 'pending-transactions',
        component: () => import('@/views/view-transaction/PendingTransactions.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/view-pin/:cardType',
        name: 'view-pin',
        component: () => import('@/views/view-pin/ViewPin.vue'),
        meta: {
            layout: 'content',
        },

    },
    {
        path: '/apply-supplementary',
        name: 'applySupplementary',
        component: () => import('@/views/apply-supplementary/ApplySupplementoryForm.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/billing-dispute/:cardType',
        name: 'billingDispute',
        component: () => import('@/views/billing-dispute/ReportBilling.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/faqs',
        name: 'faqs',
        component: () => import('@/views/faqs/Faqs.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/contact-us',
        name: 'contact-us',
        component: () => import('@/views/contact-us/Contact-us.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/alert-notifications',
        name: 'alert-notifications',
        component: () => import('@/views/alert-notifications/AlertAndNotifications'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/personal-information/:cardType',
        name: 'personal-information',
        component: () => import('@/views/personal-info/PersonalDetails.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/update-password',
        name: 'UpdatePassword',
        component: () => import('@/views/update-password/UpdatePassword.vue'),
        meta: {
            layout: 'content',
        },
    },
    {
        path: '/membership-rewards',
        name: 'membership-rewards',
        component: () => import('@/views/test/MembershipRewards.vue'),
        meta: {
            layout: 'blank'
        },
    },
]


export default apps
